// Thumbnails
import thumb1 from './images/portfolio/webp/thumbs/thumb_IMG_1128.webp';
import thumb2 from './images/portfolio/webp/thumbs/thumb_IMG_1426.webp';
import thumb3 from './images/portfolio/webp/thumbs/thumb_IMG_1428.webp';
import thumb4 from './images/portfolio/webp/thumbs/thumb_IMG_1476.webp';

import thumb5 from './images/portfolio/webp/thumbs/thumb_IMG_2821.webp';
import thumb6 from './images/portfolio/webp/thumbs/thumb_IMG_2946.webp';
import thumb7 from './images/portfolio/webp/thumbs/thumb_IMG_4110.webp';
import thumb8 from './images/portfolio/webp/thumbs/thumb_IMG_4248.webp';

import thumb9 from './images/portfolio/webp/thumbs/thumb_IMG_4289.webp';
import thumb10 from './images/portfolio/webp/thumbs/thumb_IMG_4290.webp';
import thumb11 from './images/portfolio/webp/thumbs/thumb_IMG_4344.webp';
import thumb12 from './images/portfolio/webp/thumbs/thumb_IMG_4862.webp';

import thumb13 from './images/portfolio/webp/thumbs/thumb_IMG_5151.webp';
import thumb14 from './images/portfolio/webp/thumbs/thumb_IMG_6633.webp';
import thumb15 from './images/portfolio/webp/thumbs/thumb_IMG_7655.webp';
import thumb16 from './images/portfolio/webp/thumbs/thumb_IMG_7740.webp';

import thumb17 from './images/portfolio/webp/thumbs/thumb_IMG_9100.webp';
import thumb18 from './images/portfolio/webp/thumbs/thumb_IMG_9173.webp';

import thumb19 from './images/portfolio/webp/thumbs/thumb_IMG_9176.webp';
import thumb20 from './images/portfolio/webp/thumbs/thumb_IMG_9188.webp';
import thumb21 from './images/portfolio/webp/thumbs/thumb_IMG_9239.webp';
import thumb22 from './images/portfolio/webp/thumbs/thumb_IMG_9593.webp';

// Full resolution
import img1 from './images/portfolio/webp/IMG_1128.webp';
import img2 from './images/portfolio/webp/IMG_1426.webp';
import img3 from './images/portfolio/webp/IMG_1428.webp';
import img4 from './images/portfolio/webp/IMG_1476.webp';

import img5 from './images/portfolio/webp/IMG_2821.webp';
import img6 from './images/portfolio/webp/IMG_2946.webp';
import img7 from './images/portfolio/webp/IMG_4110.webp';
import img8 from './images/portfolio/webp/IMG_4248.webp';

import img9 from './images/portfolio/webp/IMG_4289.webp';
import img10 from './images/portfolio/webp/IMG_4290.webp';
import img11 from './images/portfolio/webp/IMG_4344.webp';
import img12 from './images/portfolio/webp/IMG_4862.webp';

import img13 from './images/portfolio/webp/IMG_5151.webp';
import img14 from './images/portfolio/webp/IMG_6633.webp';
import img15 from './images/portfolio/webp/IMG_7655.webp';
import img16 from './images/portfolio/webp/IMG_7740.webp';

import img17 from './images/portfolio/webp/IMG_9100.webp';
import img18 from './images/portfolio/webp/IMG_9173.webp';

import img19 from './images/portfolio/webp/IMG_9176.webp';
import img20 from './images/portfolio/webp/IMG_9188.webp';
import img21 from './images/portfolio/webp/IMG_9239.webp';
import img22 from './images/portfolio/webp/IMG_9593.webp';

const images = [
  {
      id: 1,
      thumb: thumb1,
      filename: img1,
      title: 'F-15',
      description: 'This is the first image'
  },
  {
      id: 2,
      thumb: thumb2,
      filename: img2,
      title: 'F-18',
      description: 'This is the second image'
  },
  {
      id: 3,
      thumb: thumb3,
      filename: img3,
      title: 'F-18',
      description: 'This is the first image asdhjksah dsajh dkjlsahkjdhsakjldhkjlsa hdjklsahdjklhsakjdh'
  },
  {
      id: 4,
      thumb: thumb4,
      filename: img4,
      title: 'F-18',
      description: 'This is the second image'
  },
  {
      id: 5,
      thumb: thumb5,
      filename: img5,
      title: 'C-17',
      description: 'This is the first image'
  },
  {
      id: 6,
      thumb: thumb6,
      filename: img6,
      title: 'F-22',
      description: 'This is the second image'
  },
  {
      id: 7,
      thumb: thumb7,
      filename: img7,
      title: 'C-17',
      description: 'This is the second image'
  },
  {
      id: 8,
      thumb: thumb8,
      filename: img8,
      title: 'F-22',
      description: 'This is the first image'
  },
  {
      id: 9,
      thumb: thumb9,
      filename: img9,
      title: 'F-35',
      description: 'This is the second image'
  },
  // ------------------------------------------------------
  {
      id: 10,
      thumb: thumb10,
      filename: img10,
      title: 'F-22',
      description: 'This is the first image'
  },
  {
      id: 11,
      thumb: thumb11,
      filename: img11,
      title: 'F-22',
      description: 'This is the second image'
  },
  {
      id: 12,
      thumb: thumb12,
      filename: img12,
      title: 'Image 12',
      description: 'This is the first image'
  },
  {
      id: 13,
      thumb: thumb13,
      filename: img13,
      title: 'Image 13',
      description: 'This is the second image'
  },
  {
      id: 14,
      thumb: thumb14,
      filename: img14,
      title: 'Image 14',
      description: 'This is the first image'
  },
  {
      id: 15,
      thumb: thumb15,
      filename: img15,
      title: 'Image 15',
      description: 'This is the second image'
  },
  {
      id: 16,
      thumb: thumb16,
      filename: img16,
      title: 'Image 16',
      description: 'This is the second image'
  },
  {
      id: 17,
      thumb: thumb17,
      filename: img17,
      title: 'A-10',
      description: 'This is the first image'
  },
  {
      id: 18,
      thumb: thumb18,
      filename: img18,
      title: 'A-10',
      description: 'This is the second image'
  },
  {
      id: 19,
      thumb: thumb19,
      filename: img19,
      title: 'A-10',
      description: 'This is the second image'
  },
  {
      id: 20,
      thumb: thumb20,
      filename: img20,
      title: 'A-10',
      description: 'This is the second image'
  },
  {
      id: 21,
      thumb: thumb21,
      filename: img21,
      title: 'A-10',
      description: 'This is the second image'
  },
  {
      id: 22,
      thumb: thumb22,
      filename: img22,
      title: 'Image 22',
      description: 'This is the second image'
  },
  // ------------------------------------------------------
];

export default images;